/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 14:27:35
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-06-21 10:20:13
 * @name: 工单管理-提交售后解决方案
 * @Description: 工单管理-提交售后解决方案
 * @FilePath: \project\src\module\issue\validator\setPlan.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'run_process_id',
    description: '工作流id',
    required: true,
    required_message: '工作流id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'issue_id',
    description: '工单id',
    required: true,
    required_message: '工单id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'need_send_back',
    description: '是否需要寄回：1=》是，0=》否',
    required: true,
    required_message: 'need_send_back为必传项',
    match: (e) => {
      if (![1, 0].includes(e)) {
        return 'need_send_back值须为1或0';
      } else {
        return '';
      }
    }
  },
  {
    key: 'send_back_way',
    description: '寄回方式 0无需寄回 1先补后退 2先退后补',
    required: true,
    required_message: 'send_back_way为必传项',
    match: (e) => {
      if (![0, 1, 2].includes(e)) {
        return 'send_back_way值须为0、1或2';
      } else {
        return '';
      }
    }
  },
  {
    key: 'need_pay',
    description: '是否需要费用：1=》是，0=》否，2=》暂不填写',
    required: true,
    required_message: 'need_pay为必传项',
    match: (e) => {
      if (![1, 0, 2].includes(e)) {
        return 'need_pay值须为1、0或2';
      } else {
        return '';
      }
    }
  },
  {
    key: 'need_qa_check',
    description: '是否需要品质审核：1=》是，0=》否',
    required: false,
    match: (e) => {
      if (e && ![1, 0].includes(e)) {
        return 'need_qa_check值须为1或0';
      } else {
        return '';
      }
    }
  },
  {
    key: 'resolve_way',
    description: '处理方式 1补发配件 2上门 3更换配件',
    required: true,
    required_message: 'resolve_way为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'resolve_plan',
    description: '解决措施',
    required: false,
    match: (e) => {
      return '';
    }
  },
  {
    key: 'send_back_items',
    description: '寄回物品',
    required: false,
    errModal: 'toast',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'send_back_address',
    description: '收件人信息，如果need_send_back字段为1就必传',
    required: false,
    match: (e) => {
      return '';
    },
  },
  {
    key: 'put_in_time',
    description: '入库日期',
    required: false,
    match: (e) => {
      return '';
    }
  },
  {
    key: 'send_out_time',
    description: '发货日期',
    required: false,
    match: (e) => {
      return '';
    }
  },
]